import { render, staticRenderFns } from "./ChooseBlockPlacementModal.vue?vue&type=template&id=4ad57147&scoped=true&"
import script from "./ChooseBlockPlacementModal.vue?vue&type=script&lang=js&"
export * from "./ChooseBlockPlacementModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBlockPlacementModal.vue?vue&type=style&index=0&id=4ad57147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad57147",
  null
  
)

export default component.exports